import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";

const appTitle =
  import.meta.env.VITE_APP_SYS_TITLE || import.meta.env.VITE_APP_ENTER_TITLE;

if (appTitle) {
  document.title = appTitle;
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
